import { PixiBase } from 'bog-arcade-core-ui';

import { BallCrackType, BallType } from '../enums';
import { sharedSourceNames } from '../sourceNames';
import coordinates from './atlas.json';

class BallHelper extends PixiBase {
  constructor() {
    super();
    this.size = 120;
  }

  setResource(res) {
    this.res = res;
  }

  __getCoordinate(prefix, state) {
    return coordinates[`${prefix}_${state + 1}`];
  }

  _createTexture(position) {
    const element = this.PIXI.utils.TextureCache[sharedSourceNames.balls];
    const texture = element.clone();
    const x = position.x //- this.size / 2;
    const y = position.y //- this.size / 2;
    texture.frame = new this.PIXI.Rectangle(x, y, this.size, this.size);
    const target = new this.PIXI.Sprite(texture);
    target.anchor.set(.5);
    return target;
  }

  _getPinkBall(state = BallCrackType.none) {
    const coordinate = this.__getCoordinate('p', state);
    const ball = this._createTexture(coordinate);
    ball.color = BallType.pink;
    ball.crackState = state
    return ball;
  }

  _getMagentaBall(state = BallCrackType.none) {
    const coordinate = this.__getCoordinate('m', state);
    const ball = this._createTexture(coordinate);
    ball.color = BallType.magenta;
    ball.crackState = state;
    return ball;
  }

  _getBonusBall(state = BallCrackType.none) {
    const coordinate = this.__getCoordinate('b', state);
    const ball = this._createTexture(coordinate);
    ball.color = BallType.bonus;
    ball.crackState = state;
    return ball;
  }

  _getYellowBall(state = BallCrackType.none) {
    const coordinate = this.__getCoordinate('o', state);
    const ball = this._createTexture(coordinate);
    ball.color = BallType.yellow;
    ball.crackState = state;
    return ball;
  }

  _getGreenBall(state = BallCrackType.none) {
    const coordinate = this.__getCoordinate('g', state);
    const ball = this._createTexture(coordinate);
    ball.color = BallType.green;
    ball.crackState = state;
    return ball;
  }

  getNextState(state) {
    const newState = state + 1;
    return newState > BallCrackType.max ? BallCrackType.max : newState;
  }

  getNewPosition(index, step, length, current) {
    return index + step + length - current > 7 ? 7 : step + length + index - current;
  }

  getBall(type = BallType.pink, state = BallCrackType.none) {
    switch (type) {
      case BallType.pink:
        return this._getPinkBall(state);
      case BallType.bonus:
        return this._getBonusBall(state);
      case BallType.magenta:
        return this._getMagentaBall(state);
      case BallType.green:
        return this._getGreenBall(state);
      case BallType.yellow:
        return this._getYellowBall(state);
      default:
        return null;
    }
  }

  crackBall(type, state = BallCrackType.none) {
    return Promise.resolve(this.getBall(state, this.getNextState(state)));
  }
}

export const ballHelper = new BallHelper();
